import React, { useState, useRef, useEffect, useCallback } from 'react';

const CHAT_STYLES = `
  .cw-fab {
    position: fixed;
    bottom: 28px;
    right: 28px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    color: #fff;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 24px rgba(37,99,235,0.4), 0 0 0 0 rgba(37,99,235,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    transition: all 0.3s cubic-bezier(0.4,0,0.2,1);
    animation: cw-pulse 2s infinite;
  }
  .cw-fab:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 32px rgba(37,99,235,0.5), 0 0 0 0 rgba(37,99,235,0.3);
  }
  .cw-fab:active { transform: scale(0.95); }
  .cw-fab-badge {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #ef4444;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #fff;
  }
  .cw-fab.cw-open { animation: none; }

  @keyframes cw-pulse {
    0% { box-shadow: 0 4px 24px rgba(37,99,235,0.4), 0 0 0 0 rgba(37,99,235,0.3); }
    70% { box-shadow: 0 4px 24px rgba(37,99,235,0.4), 0 0 0 12px rgba(37,99,235,0); }
    100% { box-shadow: 0 4px 24px rgba(37,99,235,0.4), 0 0 0 0 rgba(37,99,235,0); }
  }

  .cw-window {
    position: fixed;
    bottom: 100px;
    right: 28px;
    width: 400px;
    max-height: 600px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 12px 48px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.05);
    display: flex;
    flex-direction: column;
    z-index: 9998;
    overflow: hidden;
    animation: cw-slide-up 0.3s cubic-bezier(0.4,0,0.2,1);
  }
  @keyframes cw-slide-up {
    from { opacity: 0; transform: translateY(20px) scale(0.95); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }

  .cw-header {
    background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%);
    color: #fff;
    padding: 18px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }
  .cw-header-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255,255,255,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
  }
  .cw-header-info { flex: 1; min-width: 0; }
  .cw-header-name {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: -0.01em;
  }
  .cw-header-status {
    font-size: 12px;
    color: rgba(255,255,255,0.7);
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .cw-header-status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #22c55e;
    animation: cw-dot-blink 2s infinite;
  }
  @keyframes cw-dot-blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
  .cw-header-close {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: rgba(255,255,255,0.1);
    border: none;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
    flex-shrink: 0;
  }
  .cw-header-close:hover { background: rgba(255,255,255,0.2); }

  .cw-messages {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-height: 300px;
    max-height: 380px;
    background: #f8fafc;
  }
  .cw-messages::-webkit-scrollbar { width: 5px; }
  .cw-messages::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 10px; }

  .cw-msg {
    display: flex;
    gap: 8px;
    max-width: 85%;
    animation: cw-msg-in 0.25s ease-out;
  }
  @keyframes cw-msg-in {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .cw-msg-agent { align-self: flex-start; }
  .cw-msg-user { align-self: flex-end; flex-direction: row-reverse; }

  .cw-msg-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    flex-shrink: 0;
    margin-top: 2px;
  }
  .cw-msg-agent .cw-msg-avatar { background: #0f172a; color: #fff; }
  .cw-msg-user .cw-msg-avatar { background: #2563eb; color: #fff; }

  .cw-msg-bubble {
    padding: 10px 14px;
    border-radius: 12px;
    font-size: 13.5px;
    line-height: 1.55;
    word-break: break-word;
  }
  .cw-msg-agent .cw-msg-bubble {
    background: #fff;
    color: #1e293b;
    border: 1px solid #e2e8f0;
    border-bottom-left-radius: 4px;
  }
  .cw-msg-user .cw-msg-bubble {
    background: #2563eb;
    color: #fff;
    border-bottom-right-radius: 4px;
  }

  .cw-msg-time {
    font-size: 10px;
    color: #94a3b8;
    margin-top: 4px;
    padding: 0 4px;
  }
  .cw-msg-user .cw-msg-time { text-align: right; }

  .cw-typing {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 4px;
  }
  .cw-typing-text {
    font-size: 12px;
    color: #94a3b8;
    font-style: italic;
  }
  .cw-typing-dots {
    display: flex;
    gap: 3px;
  }
  .cw-typing-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #94a3b8;
    animation: cw-typing-bounce 1.4s infinite ease-in-out;
  }
  .cw-typing-dot:nth-child(2) { animation-delay: 0.2s; }
  .cw-typing-dot:nth-child(3) { animation-delay: 0.4s; }
  @keyframes cw-typing-bounce {
    0%, 60%, 100% { transform: translateY(0); }
    30% { transform: translateY(-4px); }
  }

  .cw-quick-replies {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0 16px 10px;
    background: #f8fafc;
  }
  .cw-quick-btn {
    padding: 6px 12px;
    border-radius: 100px;
    border: 1px solid #2563eb;
    background: #eff6ff;
    color: #2563eb;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
  }
  .cw-quick-btn:hover {
    background: #2563eb;
    color: #fff;
  }

  .cw-input-area {
    padding: 12px 16px;
    border-top: 1px solid #e2e8f0;
    background: #fff;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
  .cw-input {
    flex: 1;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 10px 14px;
    font-size: 13.5px;
    font-family: inherit;
    color: #1e293b;
    outline: none;
    resize: none;
    min-height: 40px;
    max-height: 80px;
    transition: border-color 0.2s;
  }
  .cw-input:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37,99,235,0.08);
  }
  .cw-input::placeholder { color: #94a3b8; }
  .cw-send-btn {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #2563eb;
    color: #fff;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s;
  }
  .cw-send-btn:hover { background: #1d4ed8; }
  .cw-send-btn:active { transform: scale(0.92); }
  .cw-send-btn:disabled { opacity: 0.4; cursor: not-allowed; }

  .cw-powered {
    text-align: center;
    padding: 8px;
    font-size: 10px;
    color: #94a3b8;
    background: #fff;
    border-top: 1px solid #f1f5f9;
    flex-shrink: 0;
  }
  .cw-powered a { color: #64748b; text-decoration: none; font-weight: 600; }

  @media (max-width: 480px) {
    .cw-fab { bottom: 18px; right: 16px; width: 54px; height: 54px; }
    .cw-window {
      bottom: 84px; right: 12px;
      width: calc(100vw - 24px);
      max-height: min(600px, calc(100dvh - 120px));
    }
    .cw-lead-input, .cw-lead-btn { font-size: 13px; }
  }

  /* ---------- Lead capture form ---------- */
  .cw-lead {
    border-top: 1px solid #e2e8f0;
    background: #f8fafc;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 7px;
    flex-shrink: 0;
  }
  .cw-lead-title { font-size: 12px; font-weight: 800; color: #0f172a; }
  .cw-lead-input {
    border: 1px solid #e2e8f0;
    border-radius: 9px;
    padding: 9px 11px;
    font-size: 12.5px;
    font-family: inherit;
    background: #fff;
    outline: none;
  }
  .cw-lead-input:focus { border-color: #93c5fd; box-shadow: 0 0 0 3px rgba(59,130,246,.12); }
  .cw-lead-error { font-size: 11px; color: #dc2626; font-weight: 600; }
  .cw-lead-btn {
    border: none;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #fff;
    font-weight: 700;
    font-size: 13px;
    padding: 10px;
    border-radius: 9px;
    cursor: pointer;
  }
  .cw-lead-btn:hover { filter: brightness(1.08); }
  .cw-lead-skip {
    background: none;
    border: none;
    color: #64748b;
    font-size: 11.5px;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
  }

  @media (max-width: 480px) {
    .cw-fab { bottom: 20px; right: 20px; width: 54px; height: 54px; }
    .cw-window {
      bottom: 0;
      right: 0;
      left: 0;
      width: 100%;
      max-height: 100vh;
      border-radius: 0;
      animation: cw-slide-up-full 0.3s ease-out;
    }
    @keyframes cw-slide-up-full {
      from { transform: translateY(100%); }
      to { transform: translateY(0); }
    }
  }
`;

// Smart auto-reply engine
const KB = [
  { keywords: ['hello', 'hi', 'hey', 'greetings', 'good morning', 'good afternoon', 'good evening', 'salam', 'salaam'],
    replies: [
      "Hi there! 👋 Welcome to LedgerPro. I can help with pricing, features, your trial, or any technical questions. What would you like to know?",
      "Hello! Thanks for reaching out. Ask me anything about LedgerPro — plans, setup, invoicing, reports and more.",
    ] },
  { keywords: ['price', 'pricing', 'cost', 'how much', 'plan cost', 'subscription cost', 'expensive', 'cheap', 'afford', 'fee'],
    replies: [
      "Our plans:\n• Starter — $29/mo (or $290/yr)\n• Professional — $79/mo (or $790/yr) · most popular\n• Enterprise — $199/mo (or $1,990/yr)\nAll include a 14-day free trial, no credit card required. Yearly billing saves ~17%.",
    ] },
  { keywords: ['trial', 'free trial', 'demo', 'try before', 'test drive'],
    replies: [
      "Every new company gets a full-featured 14-day free trial — no credit card needed. Just register, pick a plan, and you're in. If the trial expires without purchasing, your data is safe and access resumes as soon as you subscribe.",
    ] },
  { keywords: ['yearly discount', 'annual discount', 'save', 'billed yearly', 'billed annually'],
    replies: ["Yes! Yearly billing saves about 17% compared to monthly. For example Starter is $290/yr instead of $348." ] },
  { keywords: ['refund', 'money back', 'cancel subscription', 'cancel my plan', 'downgrade'],
    replies: [
      "You can cancel anytime from Subscription settings — no cancellation fees. For refund requests on recent charges, our team will review your case personally; just ask me to connect you.",
    ] },
  { keywords: ['invoice how', 'create invoice', 'send invoice', 'new invoice', 'invoice someone'],
    replies: [
      "Creating an invoice is easy: go to Invoices → New Invoice → add your customer, line items, tax and notes → Save & Send. Customers receive a polished email they can pay from. Want help with anything specific on invoices?",
    ] },
  { keywords: ['estimate', 'quote', 'quotation'],
    replies: [
      "Estimates work just like invoices: Estimates → New Estimate. Once your customer approves, convert it to an invoice with one click — no re-typing.",
    ] },
  { keywords: ['payment method', 'get paid', 'accept payment', 'online payment', 'pay now'],
    replies: [
      "Invoices include a Pay Now button for your customers. Payments are recorded against the invoice automatically, and you can also log manual payments from the Payments page.",
    ] },
  { keywords: ['expense', 'receipt', 'track spending'],
    replies: [
      "Track expenses under Expenses → New Expense. Pick a category (rent, travel, utilities...), attach amounts and payment method — everything flows into your reports automatically.",
    ] },
  { keywords: ['report', 'profit', 'loss', 'balance sheet', 'cash flow', 'trial balance', 'tax report'],
    replies: [
      "You get 40+ live reports: Profit & Loss, Balance Sheet, Cash Flow, Trial Balance, AR/AP aging, sales by customer/product, inventory valuation and more — all under Reports. Every number traces back to the double-entry ledger.",
    ] },
  { keywords: ['bank', 'reconcile', 'reconciliation', 'connect bank', 'import bank'],
    replies: [
      "Under Banking you can manage accounts, record transfers, write checks and run full reconciliations against statements. Matching transactions takes seconds with the auto-match suggestions.",
    ] },
  { keywords: ['inventory', 'stock', 'product tracking', 'low stock'],
    replies: [
      "Inventory tracks quantity on hand, committed and available, with average-cost valuation and low-stock alerts. Adjustments post straight to your ledger so stock value always matches the books.",
    ] },
  { keywords: ['user', 'team', 'invite', 'roles', 'permissions', 'accountant access'],
    replies: [
      "Invite unlimited team members (plan limits apply) under Settings → Users. Assign roles like Accountant, Manager, Sales, Purchase or Read-Only — each role has granular module permissions.",
    ] },
  { keywords: ['multi company', 'second company', 'another company', 'multiple businesses'],
    replies: ["Each registration creates its own company workspace. To run another business, simply register a new company with the same or a different email — data stays fully separated."] },
  { keywords: ['currency', 'exchange rate', 'multi currency', 'usd', 'afn', 'euro'],
    replies: [
      "Multi-currency is built in. Set your base currency during signup and manage exchange rates under Settings → Currency. Foreign-currency transactions convert automatically.",
    ] },
  { keywords: ['import', 'migrate', 'quickbooks import', 'xero import', 'csv import', 'excel import', 'move data'],
    replies: [
      "You can import customers, vendors, products, chart of accounts and opening balances from CSV/Excel (Settings → Backup & Import). Coming from QuickBooks or Xero? Export their lists to CSV and follow the same wizard.",
    ] },
  { keywords: ['export', 'backup', 'download data', 'my data'],
    replies: [
      "Your data is always yours: export reports to PDF/Excel/CSV, download JSON backups, or generate a full database backup from Settings → Backup.",
    ] },
  { keywords: ['security', 'safe', 'encrypt', 'privacy', 'gdpr', 'data protection'],
    replies: [
      "Security essentials: encrypted connections (TLS), bcrypt-hashed passwords, JWT auth with expiry, role-based permissions and a complete audit trail of every change. See our Security page for details.",
    ] },
  { keywords: ['forgot password', 'reset password', 'password reset', "can't log in", 'cannot login', 'login problem', 'sign in problem'],
    replies: [
      "Use 'Forgot password?' on the sign-in page — we'll email you a secure reset link valid for 1 hour. Still stuck after resetting? Ask me to connect you with support.",
    ] },
  { keywords: ['tax', 'vat', 'sales tax', 'gst'],
    replies: [
      "Configure tax rates and groups under Tax Settings, apply them per line item, and pull Sales/Purchase tax reports anytime. Tax liabilities post to their own ledger account automatically.",
    ] },
  { keywords: ['payroll', 'salary', 'employee payment', 'payslip'],
    replies: [
      "Employees and payslips are managed under Employees & Payroll — generate payslips, track salaries and post payroll entries to the ledger.",
    ] },
  { keywords: ['who are you', 'are you a bot', 'real person', 'human', 'are you robot'],
    replies: [
      "I'm the LedgerPro assistant 🤖 — I can answer most product questions instantly. For anything I can't fully solve, I'll pass your question to our human team with your contact details so they can follow up.",
    ] },
  { keywords: ['thank', 'thanks', 'great', 'awesome', 'perfect', 'nice'],
    replies: ["You're very welcome! 😊 Anything else I can help with?", "Happy to help! Let me know if anything else comes up."] },
  { keywords: ['bye', 'goodbye', 'see you', 'later', 'good night'],
    replies: ["Thanks for chatting with us! Good luck with your business — we're here whenever you need us. 👋"] },
  { keywords: ['contact sales', 'talk to sales', 'sales team', 'custom plan', 'enterprise deal', 'call me'],
    replies: [
      "Absolutely — share your name, email and phone below and our sales team will reach out shortly. You can also use the Contact page anytime.",
      "Sure! Leave your name, email and phone number and sales will contact you — usually within one business day.",
    ] },
];

// Legacy map kept for quick-reply labels
const AUTO_REPLIES = {
  pricing: KB[1].replies,
  trial: KB[2].replies,
  support: ["I'd be happy to help with technical support! Describe the issue (plus any error messages) and if I can't solve it here, I'll route you to our specialist team."],
  security: ["Security essentials: encrypted connections (TLS), bcrypt-hashed passwords, JWT auth with expiry, role-based permissions and a complete audit trail of every change. See our Security page for details."],
  billing: ["For billing questions: subscription changes, payments, invoices & receipts, cancellations or refunds — ask away, or type 'contact sales' to reach a human."],
  features: ["LedgerPro includes invoicing, estimates, bills, banking, inventory, payroll, taxes, 40+ reports, multi-user roles and much more. Which area interests you?"],
  default: [],
};

function getAutoReply(text) {
  const lower = ' ' + String(text).toLowerCase() + ' ';
  let best = null;
  let bestScore = 0;
  for (const topic of KB) {
    let score = 0;
    for (const kw of topic.keywords) {
      if (lower.includes(kw)) score += kw.includes(' ') ? 2 : 1;
    }
    if (score > bestScore) { bestScore = score; best = topic; }
  }
  if (!best) return null;
  return best.replies[Math.floor(Math.random() * best.replies.length)];
}

const FALLBACK_PROMPT =
  "That's a great question — I want to make sure a real specialist answers it correctly rather than guessing.\n\n" +
  "Could you quickly share your **name**, **email** and **phone number**? Our team will reply to you directly — usually within a few hours, at most within 24.";

function stripMd(s) { return s.replace(/\*\*/g, ''); }

const QUICK_REPLIES = [
  'Pricing & Plans',
  'Free Trial',
  'Technical Support',
  'Billing Help',
  'Security',
  'Features',
];

const INIT_MESSAGES = [
  {
    id: 'welcome',
    sender: 'agent',
    text: "Hi there! 👋 I'm the LedgerPro support assistant. How can I help you today?",
    time: new Date().toISOString(),
  },
];

function formatTime(iso) {
  const d = new Date(iso);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState(INIT_MESSAGES);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  const [unread, setUnread] = useState(0);
  // Lead capture: when the assistant can't answer, collect name/email/phone
  const [stage, setStage] = useState('chat'); // 'chat' | 'collect' | 'done'
  const [lead, setLead] = useState({ name: '', email: '', phone: '' });
  const [leadErr, setLeadErr] = useState('');
  const sessionIdRef = useRef('web-' + Date.now());
  const lastQuestionRef = useRef('');
  const contactRef = useRef(null);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const scrollToBottom = useCallback(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages, typing, open, stage, scrollToBottom]);

  useEffect(() => {
    if (open) {
      setUnread(0);
      setTimeout(() => inputRef.current?.focus(), 300);
    }
  }, [open]);

  /** Persist a message server-side so superadmin sees the conversation */
  const persistMessage = useCallback((text, extra = {}) => {
    fetch((process.env.REACT_APP_API_URL || '/api') + '/platform/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: text,
        sessionId: sessionIdRef.current,
        name: contactRef.current?.name || undefined,
        email: contactRef.current?.email || undefined,
        phone: contactRef.current?.phone || undefined,
        ...extra,
      }),
    }).catch(() => {});
  }, []);

  const pushBot = useCallback((text) => {
    setMessages(prev => [...prev, { id: Date.now() + 1, sender: 'agent', text, time: new Date().toISOString() }]);
    if (!open) setUnread(prev => prev + 1);
  }, [open]);

  const sendMessage = useCallback((text) => {
    if (!text.trim()) return;
    lastQuestionRef.current = text.trim();

    setMessages(prev => [...prev, { id: Date.now(), sender: 'user', text: text.trim(), time: new Date().toISOString() }]);
    setInput('');

    // Save to backend (fire and forget)
    persistMessage(text);
    setTyping(true);

    // Simulate agent typing delay
    const delay = 700 + Math.random() * 900;
    setTimeout(() => {
      const reply = getAutoReply(text);
      if (reply) {
        pushBot(reply);
      } else if (stage !== 'collect' && !contactRef.current) {
        // Unknown question → start lead capture
        setStage('collect');
        pushBot(FALLBACK_PROMPT);
        persistMessage('[bot] requested contact details for unanswered question: ' + text.trim(), { needsHuman: true });
      } else {
        // Contact already known (or already collecting) — route to human team
        pushBot(
          contactRef.current
            ? `Noted! Our team has your follow-up (${contactRef.current.email}) and will get back to you shortly. 🙏`
            : FALLBACK_PROMPT
        );
        persistMessage(text, { needsHuman: true });
      }
      setTyping(false);
    }, delay);
  }, [open, stage, pushBot, persistMessage]);

  const handleLeadSubmit = (e) => {
    e.preventDefault();
    const name = lead.name.trim();
    const email = lead.email.trim();
    const phone = lead.phone.trim();
    if (!name) return setLeadErr('Please enter your name');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return setLeadErr('Please enter a valid email address');
    setLeadErr('');

    contactRef.current = { name, email, phone };
    persistMessage(
      `[contact details] ${name} · ${email}${phone ? ' · ' + phone : ''} — awaiting answer for: "${lastQuestionRef.current}"`,
      { needsHuman: true, name, email, phone }
    );

    pushBot(
      `Thank you, ${name.split(' ')[0]}! ✅ Your question has been passed to our support team.\n\n` +
      `We'll reply to ${email} — usually within a few hours, at most within 24 hours.\n` +
      `Feel free to keep asking me anything in the meantime!`
    );
    setStage('done');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendMessage(input);
  };

  const handleQuickReply = (reply) => {
    sendMessage(reply);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <>
      <style>{CHAT_STYLES}</style>

      {/* Chat Window */}
      {open && (
        <div className="cw-window">
          {/* Header */}
          <div className="cw-header">
            <div className="cw-header-avatar">💬</div>
            <div className="cw-header-info">
              <div className="cw-header-name">LedgerPro Support</div>
              <div className="cw-header-status">
                <span className="cw-header-status-dot" />
                Online — typically replies instantly
              </div>
            </div>
            <button className="cw-header-close" onClick={() => setOpen(false)} title="Close chat">
              <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Messages */}
          <div className="cw-messages">
            {messages.map((msg) => (
              <div key={msg.id} className={`cw-msg cw-msg-${msg.sender}`}>
                <div className="cw-msg-avatar">
                  {msg.sender === 'agent' ? 'L' : 'Y'}
                </div>
                <div>
                  <div className="cw-msg-bubble" style={{ whiteSpace: 'pre-line' }}>
                    {msg.text}
                  </div>
                  <div className="cw-msg-time">{formatTime(msg.time)}</div>
                </div>
              </div>
            ))}
            {typing && (
              <div className="cw-msg cw-msg-agent">
                <div className="cw-msg-avatar">L</div>
                <div>
                  <div className="cw-typing">
                    <div className="cw-typing-dots">
                      <span className="cw-typing-dot" />
                      <span className="cw-typing-dot" />
                      <span className="cw-typing-dot" />
                    </div>
                    <span className="cw-typing-text">typing...</span>
                  </div>
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Lead capture — shown when the assistant can't answer */}
          {stage === 'collect' && (
            <form className="cw-lead" onSubmit={handleLeadSubmit}>
              <div className="cw-lead-title">Connect me with a specialist</div>
              <input className="cw-lead-input" placeholder="Full name *" value={lead.name}
                onChange={e => setLead({ ...lead, name: e.target.value })} />
              <input className="cw-lead-input" type="email" placeholder="Email address *" value={lead.email}
                onChange={e => setLead({ ...lead, email: e.target.value })} />
              <input className="cw-lead-input" type="tel" placeholder="Phone number (optional)" value={lead.phone}
                onChange={e => setLead({ ...lead, phone: e.target.value })} />
              {leadErr && <div className="cw-lead-error">{leadErr}</div>}
              <button type="submit" className="cw-lead-btn">Send to our team</button>
              <button type="button" className="cw-lead-skip" onClick={() => setStage('chat')}>
                Maybe later
              </button>
            </form>
          )}

          {/* Quick Replies (only show if few messages) */}
          {messages.length <= 2 && (
            <div className="cw-quick-replies">
              {QUICK_REPLIES.map((qr) => (
                <button key={qr} className="cw-quick-btn" onClick={() => handleQuickReply(qr)}>
                  {qr}
                </button>
              ))}
            </div>
          )}

          {/* Input */}
          <form className="cw-input-area" onSubmit={handleSubmit}>
            <textarea
              ref={inputRef}
              className="cw-input"
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              rows={1}
            />
            <button type="submit" className="cw-send-btn" disabled={!input.trim()}>
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M22 2L11 13" />
                <path d="M22 2L15 22L11 13L2 9L22 2Z" />
              </svg>
            </button>
          </form>

          <div className="cw-powered">
            Powered by <a href="/login">LedgerPro</a> · Live Support
          </div>
        </div>
      )}

      {/* Floating Action Button */}
      <button
        className={`cw-fab ${open ? 'cw-open' : ''}`}
        onClick={() => setOpen(!open)}
        title={open ? 'Close chat' : 'Chat with us'}
      >
        {unread > 0 && !open && <span className="cw-fab-badge">{unread}</span>}
        {open ? (
          <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        ) : (
          <svg width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
          </svg>
        )}
      </button>
    </>
  );
}
